// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"TableOfContents_sectionWrapper__M0hH4","sectionName":"TableOfContents_sectionName__21iPT"};